export const events = {
  workboard: {
    reArrangeKanban: 'reArrangeKanban-',
    reArrangeOrders: 'reArrangeOrders-',
    columnAddedKanban: 'columnAddedKanban-',
    cardAddedKanban: 'cardAddedKanban-',
    columnDeleteKanban: 'columnDeleteKanban-',
    cardArchicveKanban: 'cardArchicveKanban-',
    columnArchicveKanban: 'columnArchicveKanban-',
    cardWFStatusUpdateKanban: 'cardWFStatusUpdateKanban-',
    updateOrder: 'updateOrder-',
    workboard: 'workboard-',
  },
  order: {
    workflowUpdate: 'workflowUpdate-',
  },
  notifications: {
    notifications: 'notifications-',
    tech: 'notifications-tech-',
  },
};
